import CompanyType from "@SearchResults/types/company/Company.type";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";
import {RouteTransferTypeValuesType} from "@Route/features/transportType/types/routeTransferType.type";
import RouteType from "@Route/types/Route.type";
import aFilterDuplicates from "@Array/aFilterDuplicates";

export default function allOperatorsForTypeGetter(
    companies: Record<string, CompanyType>,
    singleRoutes: RoutesOrganizedByTransportTypeType
) {
    const getAllOperatorsForType = (routeTransferType: RouteTransferTypeValuesType) => {
        const companyIds: string[] = aFilterDuplicates(singleRoutes[routeTransferType].map((route: RouteType) => (
            route.companyId
        )))

        const companyNames = companyIds.map((companyId) => (
            companies[companyId].name
        ))

        return aFilterDuplicates(companyNames).sort((companyNameA, companyNameB) => (
            companyNameA > companyNameB
        ))
    }

    return {
        getAllOperatorsForType,
    }
}